import { getCurrentOs } from "../util/os.js";
import { useCallback } from "react";

//#region src/hooks/use-save-contact.ts
const userOs = getCurrentOs();
const saveIOSContact = (downloadName, downloadUrl) => {
	const headers = new Headers();
	headers.append("Content-type", "text/vcard; charset=utf-8");
	headers.append("Content-Disposition", `attachment; filename="${downloadName}";`);
	fetch(downloadUrl, { headers }).then((response) => response.blob()).then((blob) => {
		const blobUrl = window.URL.createObjectURL(blob);
		const anchor = document.createElement("a");
		anchor.href = blobUrl;
		anchor.download = downloadName;
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
		window.URL.revokeObjectURL(blobUrl);
	}).catch(() => {}).finally(() => {});
};
const saveContact = (downloadName, downloadUrl) => {
	const anchor = document.createElement("a");
	anchor.download = downloadName;
	anchor.href = downloadUrl;
	anchor.type = "text/vcard";
	anchor.target = "_blank";
	anchor.click();
};
const useSaveContact = ({ downloadName, downloadUrl }) => {
	const iOSHandler = useCallback(() => saveIOSContact(downloadName, downloadUrl), [downloadName, downloadUrl]);
	const defaultHandler = useCallback(() => saveContact(downloadName, downloadUrl), [downloadName, downloadUrl]);
	if (userOs === "ios") return iOSHandler;
	return defaultHandler;
};

//#endregion
export { useSaveContact };